import { render, staticRenderFns } from "./WorkingDetail.vue?vue&type=template&id=27085747"
import script from "./WorkingDetail.vue?vue&type=script&lang=js"
export * from "./WorkingDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27085747')) {
      api.createRecord('27085747', component.options)
    } else {
      api.reload('27085747', component.options)
    }
    module.hot.accept("./WorkingDetail.vue?vue&type=template&id=27085747", function () {
      api.rerender('27085747', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/WorkingDetail.vue"
export default component.exports